import {Directive, Host, HostListener, Self} from '@angular/core';
import {Calendar} from 'primeng/calendar';

/**
 * Custom directive to enable UTC dates.
 * Solves this problem: https://github.com/primefaces/primeng/issues/5853
 */

@Directive({
  selector: '[wsdUseUtc]'
})
export class WsdUseUtcDirective {

  constructor(@Host() @Self() private calendar: Calendar) { }

  @HostListener('onSelect', ['$event']) onSelect() {
    this.toUtc();
  }

  @HostListener('onInput', ['$event']) onInput() {
    this.toUtc();
  }

  private toUtc() {
    this.calendar.value = new Date(Date.UTC(this.calendar.value.getFullYear()
      , this.calendar.value.getMonth()
      , this.calendar.value.getDate()
      , 0, 0, 0));
    this.calendar.updateModel(this.calendar.value);
  }
}
